import { render, staticRenderFns } from "./InstitutionsView.vue?vue&type=template&id=232074ed"
import script from "./InstitutionsView.vue?vue&type=script&lang=js"
export * from "./InstitutionsView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports